var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgApi = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 11,
  viewBox: "0 0 15 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.66667 10.6667C2.65556 10.6667 1.79167 10.3167 1.075 9.61667C0.358333 8.91667 0 8.06111 0 7.05C0 6.18333 0.261111 5.41111 0.783333 4.73333C1.30556 4.05556 1.98889 3.62222 2.83333 3.43333C3.11111 2.41111 3.66667 1.58333 4.5 0.95C5.33333 0.316667 6.27778 0 7.33333 0C8.63333 0 9.73611 0.452778 10.6417 1.35833C11.5472 2.26389 12 3.36667 12 4.66667C12.7667 4.75556 13.4028 5.08611 13.9083 5.65833C14.4139 6.23056 14.6667 6.9 14.6667 7.66667C14.6667 8.5 14.375 9.20833 13.7917 9.79167C13.2083 10.375 12.5 10.6667 11.6667 10.6667H3.66667Z",
  fill: "#4F4F4F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgApi);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/api.e3d93542debce2d1f5dd0ee9db2dc1ec.svg";